import {contractTransactionFees, minimumTransactionFees} from '#/utils/contract-consts';

export const getTransactionFees = (stableTokenAmount: number) =>
  stableTokenAmount === 0
    ? 0
    : Math.round(Math.max(stableTokenAmount * contractTransactionFees, minimumTransactionFees));

export const getMinimumTransactionFees = (stableTokenAmount: number) =>
  stableTokenAmount === 0 ? 0 : minimumTransactionFees;
